module.exports = __webpack_public_path__ + "img/RPA.ec14968e.png";